<template>
	<div v-if="blogPostStyle === 'card' || blogPostStyle === 'list'" class="rn-card box-card-style-default"
		:class="{'card-list-view': blogPostStyle === 'list', 'home-product-card': isHomeCard}">
		<div class="inner">
			<div class="thumbnail" :style="thumbnailStyle">
				<router-link class="image" :to="productDetailUrl">
					<img class="w-100" :src="blog.img" :alt="blog.title" :style="imgStyle">
				</router-link>
			</div>
			<div class="content">
				<ul v-if="blogPostStyle === 'card'" class="rn-meta-list">
					<li>
						<router-link :to="categoryUrl">
							{{ blog.author }}
						</router-link>
					</li>
					<li class="separator">/</li>
					<li>
						<router-link :to="productDetailUrl">
							{{ blog.publishedAt }}
						</router-link>
					</li>
				</ul>
				<h4 class="title">
					<router-link :to="productDetailUrl">
						{{ blog.title }}
					</router-link>
				</h4>
				<ul v-if="blogPostStyle === 'list'" class="rn-meta-list">
					<li>
						<router-link :to="categoryUrl">
							{{ blog.author }}
						</router-link>
					</li>
					<li class="separator">/</li>
					<li>
						<router-link :to="productDetailUrl">
							{{ blog.publishedAt }}
						</router-link>
					</li>
				</ul>
				<p v-if="blogPostStyle === 'list'" class="descriptiion">
					{{ blog.excerpt }}
				</p>
			</div>
		</div>
	</div>

	<div v-else-if="blogPostStyle == 2" class="rn-card box-card-style-default edge-card-list-view">
		<div class="inner">
			<div class="onlycontent">
				<ProductTable :table-data="productsIntro" :table-data-key="productsIntroKey"></ProductTable>
			</div>
		</div>
	</div>
</template>

<script>
	import ProductTable from '../../components/elements/table/ProductsIntroTable.vue'

	export default {
		name: 'BlogPost',
		components:{
			ProductTable
		},
		props: {
			blog: {},
			productsIntroKey: '',
			productsIntro: {},
			blogPostStyle: {
				type: String,
				default: 'card'
			},
			categoryId: {
				type: String,
				default: ''
			},
			productTypeId: {
				type: String,
				default: ''
			},
			isHomeCard: {
				type: Boolean,
				default: false
			},
			// 图片最大高度，单位px，为空则使用默认值
			// 调整方法：传入数字字符串，如 imgMaxHeight: '300' 表示图片最大高度300px
			imgMaxHeight: {
				type: String,
				default: ''
			},
			// 图片宽度，单位px，为空则自适应（width: auto）
			// 调整方法：传入数字字符串，如 imgWidth: '200' 表示图片宽度200px
			imgWidth: {
				type: String,
				default: ''
			},
			// 图片容器最小高度，单位px，为空则使用默认值
			// 调整方法：传入数字字符串，如 thumbnailMinHeight: '350' 表示容器最小高度350px
			thumbnailMinHeight: {
				type: String,
				default: ''
			}
		},
		computed: {
			categoryUrl() {
				if (this.categoryId) {
					return `/products/${this.categoryId}`;
				}
				return '#';
			},
			productDetailUrl() {
				if (this.productTypeId) {
					return `/product-detail/${this.productTypeId}`;
				}
				return '#';
			},
			// 图片动态样式
			imgStyle() {
				const style = {};
				if (this.imgMaxHeight) {
					style.maxHeight = this.imgMaxHeight + 'px';
				}
				if (this.imgWidth) {
					style.width = this.imgWidth + 'px';
					style.maxWidth = this.imgWidth + 'px';
				}
				return style;
			},
			// 图片容器动态样式
			thumbnailStyle() {
				const style = {};
				if (this.thumbnailMinHeight) {
					style.minHeight = this.thumbnailMinHeight + 'px';
				}
				return style;
			}
		}
	}
</script>

<style scoped>
	.rn-card .inner .content {
		display: block;
	}
	.rn-card .inner .content .rn-meta-list {
		width: 100%;
	}
	.rn-card .inner .content .title {
		width: 100%;
	}
	/* ========== 首页产品卡片样式 ========== */
	/* 图片容器：控制图片区域的最小高度和内边距 */
	.home-product-card .inner .thumbnail {
		padding: 10px 20px 0 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 380px; /* 图片容器默认最小高度，可通过 thumbnailMinHeight prop 单独调整 */
	}
	/* 图片链接容器：占满容器，居中显示图片 */
	.home-product-card .inner .thumbnail .image {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	/* 图片本身：保持比例，等比缩放，最大高度限制 */
	.home-product-card .inner .thumbnail img {
		width: auto !important;
		max-width: 100%;
		max-height: 360px; /* 图片默认最大高度，可通过 imgMaxHeight prop 单独调整 */
		object-fit: contain; /* 保持图片比例，完整显示 */
	}
	/* 内容区域：标题和分类信息的上下内边距 */
	.home-product-card .inner .content {
		padding-top: 0;
		padding-bottom: 25px;
	}
</style>
